import React, {ReactElement, useState} from 'react';
import Lightbox from 'yet-another-react-lightbox';
import Counter from 'yet-another-react-lightbox/plugins/counter';
import Download from 'yet-another-react-lightbox/plugins/download';
import Slideshow from 'yet-another-react-lightbox/plugins/slideshow';
import Thumbnails from 'yet-another-react-lightbox/plugins/thumbnails';
import Zoom from 'yet-another-react-lightbox/plugins/zoom';
import {IElementImageGallery} from '../../../../incase-domain/elements/imageGallery';
import NobulaLogo from '../../../../../assets/icons/NobulaLogo.svg';
import 'yet-another-react-lightbox/styles.css';
import 'yet-another-react-lightbox/plugins/counter.css';
import 'yet-another-react-lightbox/plugins/thumbnails.css';
import {useStopPropagateKeyboardEvents} from '../../../../hooks/useStopPropagateKeyboardEvents';

interface ElementImageGalleryComponentProps {
    element: IElementImageGallery;
}

const NAVIGATION_KEYS = new Set(['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'PageUp', 'PageDown']);

function ElementImageGallery(props: ElementImageGalleryComponentProps): ReactElement {
    const {element} = props;
    const {images, numberOfImagesInARow, imageMargin} = element;

    const [open, setOpen] = useState(false);
    const [slideIndex, setSlideIndex] = useState<number | undefined>(undefined);

    useStopPropagateKeyboardEvents(open, NAVIGATION_KEYS);

    const imageSlides = images.map((image) => {
        return {src: image.imageSrc};
    });

    const showButtons = imageSlides.length <= 1 ? () => null : undefined;

    const marginsStyle = {
        marginLeft: `${imageMargin}em`,
        marginRight: `${imageMargin}em`,
    } as React.CSSProperties;

    return (
        <>
            <div style={{display: 'grid', gridTemplateColumns: `repeat(${numberOfImagesInARow}, 1fr)`, pointerEvents: 'auto'}}>
                {images.length === 0
                    ? [...Array(numberOfImagesInARow)].map(() => {
                          return <img width="100%" height="auto" src={NobulaLogo} alt="" />;
                      })
                    : images?.map((image, index) => {
                          return (
                              <div
                                  key={index}
                                  onClick={() => {
                                      setOpen(true);
                                      setSlideIndex(index);
                                  }}
                                  style={{...marginsStyle, cursor: 'pointer'}}
                              >
                                  <img width="100%" height="auto" src={image.imageSrc} alt="" />
                              </div>
                          );
                      })}
            </div>
            <Lightbox
                open={open}
                close={() => {
                    setOpen(false);
                }}
                slides={imageSlides}
                index={slideIndex}
                plugins={[Counter, Download, Slideshow, Thumbnails, Zoom]}
                counter={{container: {style: {top: 'unset', bottom: 0}}}}
                animation={{zoom: 500}}
                render={{
                    buttonPrev: showButtons,
                    buttonNext: showButtons,
                    iconSlideshowPlay: showButtons,
                }}
                zoom={{
                    scrollToZoom: true,
                    maxZoomPixelRatio: 5,
                }}
            />
        </>
    );
}

export default React.memo(ElementImageGallery);
